var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotSubmitted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99035 1.25098C5.16106 1.25098 1.24609 5.16604 1.24609 9.99519C1.24609 14.8244 5.16106 18.7394 9.99035 18.7394C14.8195 18.7394 18.7345 14.8243 18.7345 9.99519C18.7345 5.16604 14.8195 1.25098 9.99035 1.25098ZM9.99035 17.4989C5.85247 17.4989 2.48661 14.1325 2.48661 9.99519C2.48661 5.85737 5.85279 2.4915 9.99035 2.4915C14.1277 2.4915 17.494 5.85777 17.494 9.99519C17.494 14.133 14.1282 17.4989 9.99035 17.4989Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61328 9.36523H14.3669V10.6243H5.61328V9.36523Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSubmitted);
export default __webpack_public_path__ + "static/media/not-submitted.6ad1a4114a1192c0dddbf61f3577c482.svg";
export { ForwardRef as ReactComponent };